/* eslint-disable react/no-array-index-key */
import {FormControl, FormControlLabel, FormLabel, Radio, RadioGroup} from '@mui/material';
import React from 'react';
import {useIntl} from 'react-intl';

import {FilterConfig} from './LightFormatter';
import {LightInputLabel} from './LightInputLabel';

type Option = {
  id: any;
  label: string;
};
type Props = {
  config: FilterConfig;
  optional?: boolean;
  options: Option[];
  value: any;
  onChange: (newValue: any) => void;
  style?: React.CSSProperties;
};
export const LightRadio: React.FC<Props> = (props) => {
  const {config, optional, options, value, onChange, ...extraProps} = props;
  const labelName = `${config.name}-label`;
  const intl = useIntl();
  return (
    <FormControl {...extraProps}>
      {config.ui.label && (
        <FormLabel id={labelName}>{<LightInputLabel text={config.ui.label} optional={optional} intl={intl} />}</FormLabel>
      )}
      <RadioGroup
        style={{columnGap: 8}}
        row
        name={config.name}
        aria-labelledby={labelName}
        value={value ?? null}
        onChange={(event) => onChange(event.target.value)}
      >
        {options.map((v, i) => (
          <FormControlLabel key={`${v.id}-${i}`} value={v.id} control={<Radio />} label={v.label} />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
